/* Product Tile Markup - You can play around with this to change the
information that appears on the Wishlisted Product tiles  */

var productCardMarkupPage = `<div class="swym-wishlist-grid">
   {{#products}}
   <a href="{{du}}"aria-label="{{dt}}" class="swym-wishlist-item swym-is-anchor">
     <button id="swym-remove-productBtn" aria-label="Delete" data-variant-id="{{epi}}" data-product-id="{{empi}}" class="swym-delete-btn swym-nav swym-nav-1 swym-is-button">
       <span class="swym-icon swym-heart">
       </span>
     </button>
     <div class="swym-wishlist-image-wrapper">
       <img alt="{{dt}}" class="swym-wishlist-image" src="{{iu}}">
     </div>
     <button class="swym-is-button">
       <div class="swym-title swym-title-1">
         {{dt}}
       </div>
     </button>
      <div class="swym-variant-title swym-text swym-title-2 swym-variant-title-spacer"></div>
     <div class="swym-product-price swym-text swym-text-1">
       <div class="swym-product-final-price swym-value">
         {{cu}}{{pr}}
       </div>
       {{#variantinfo}}
       <div class="swym-variant-title swym-text swym-title-2 swym-variant-title-spacer dilimeter">
          &nbsp;│&nbsp;
       </div>
       {{/variantinfo}}
       <div class="swym-variant-title swym-text swym-title-2 swym-variant-title-spacer vinfo">
       {{variantinfo}}
       </div>
     </div>
   </a>
   {{/products}}
</div>`;

var productCardMarkup = `<div class="swym-wishlist-grid wishlist-grid-desktop">
   {{#products}} 
   <a href="{{du}}"aria-label="{{dt}}" class="swym-wishlist-item swym-is-anchor">
     <div class="flex modal-wishlist-items">
        <div class="swym-wishlist-image-wrapper">
            <img alt="{{dt}}" class="swym-wishlist-image" src="{{iu}}">
        </div>
        <div class="swym-wishlist-product-details">
            <div class="swym-title swym-title-1">
                {{dt}}
            </div>
            <div class="swym-product-price swym-text swym-text-1">
                <div class="swym-product-final-price swym-value">
                  {{cu}}{{pr}}
                </div>
            </div>
            <button id="swym-remove-productBtn" aria-label="Delete" data-variant-id="{{epi}}" data-product-id="{{empi}}" class="swym-delete-btn swym-nav swym-nav-1 swym-is-button">
             Remove
           </button>
        </div>
     </div>
   </a>
   {{/products}}
</div>`;


function getVariantInfo(variants) {
	try {
		let variantKeys = ((variants && variants != "[]") ? Object.keys(JSON.parse(variants)[0]) : []),
			variantinfo;
		if (variantKeys.length > 0) {
			variantinfo = variantKeys[0];
			if (variantinfo == "Default Title") {
				variantinfo = "";
			}
		} else {
			variantinfo = "";
		}
		return variantinfo;
	} catch (err) {
		return variants;
	}
}

function onAddToCartClick(e) {
	e.preventDefault();
	var productId = e.currentTarget.getAttribute("data-product-id");
	var variantId = e.currentTarget.getAttribute("data-variant-id");
	var du = e.target.getAttribute("data-product-url");
	e.target.innerHTML = "Adding..";
	window._swat.replayAddToCart({
		empi: productId,
		du: du
	}, variantId, function(c) {
		e.target.innerHTML = "Added to Cart";
		e.target.setAttribute("data-state-cart", "swym-added");
		console.log("Successfully added product to cart.", c);
	}, function(e) {
		console.log(e);
	});
}

function onRemoveBtnClick(e) {
	e.preventDefault();
	var epi = +e.currentTarget.getAttribute("data-variant-id");
	var empi = +e.currentTarget.getAttribute("data-product-id");
	window._swat.fetch(function(products) {
		products.forEach(function(product) {
			if (epi && empi && product.epi == epi && product.empi == empi){
				window._swat.removeFromWishList(product, function() {
					if (!window.SwymCallbacks) {
						window.SwymCallbacks = [];
					}
					window.SwymCallbacks.push(swymRenderWishlist);
				});
			}
		});
	})
}

function swymRenderWishlist(swat) {
	// Get wishlist items
	swat.fetch(function(products) {
		
		var wishlistContentsContainer = document.getElementById("wishlist-items-container");
        var wishlistContentsContainerPage = document.getElementById("wishlist-items-container-page");
        var wishlistCount = document.getElementById("wishlistcount");
		var formattedWishlistedProducts = products.map(function(p) {
			p = SwymUtils.formatProductPrice(p); // formats product price and adds currency to product Object
			p.isInCart = _swat.platform.isInDeviceCart(p.epi) || (p.et == _swat.EventTypes.addToCart);
			p.variantinfo = (p.vi ? getVariantInfo(p.vi) : "");
			return p;
		});
       console.log("itemsProduct:", formattedWishlistedProducts);
		var productCardsMarkup = SwymUtils.renderTemplateString(productCardMarkup, {
			products: formattedWishlistedProducts
		});
      
		if(wishlistContentsContainer){
			wishlistContentsContainer.innerHTML = productCardsMarkup;
			attachClickListeners();
		} else{
           console.log("Container not found, Wishlist Page element not found");
		}

        var productCardsMarkupPage = SwymUtils.renderTemplateString(productCardMarkupPage, {
			products: formattedWishlistedProducts
		});

        var wishListTag = document.querySelector('.custom-wishlist-a')
        var productCount = formattedWishlistedProducts.length;
        console.log("Number of products in the wishlist: " + productCount)
      
        if(wishlistContentsContainerPage){
			wishlistContentsContainerPage.innerHTML = productCardsMarkupPage;
			attachClickListeners();
          if (productCount === 0){
             wishlistContentsContainerPage.innerHTML = `<div style="width:100%;text-align:center;"><h2 class="h1">Your Wishlist Is Currently Empty</h2></div>`;
          }
		} else{
          console.log("Container not found, Wishlist Page element not found");
		}


        
        if (productCount === 0 ){
          wishlistCount.style.display = 'none' 
          wishListTag.removeAttribute('onmouseover');
        }else{
          wishlistCount.style.display = 'block' 
          wishListTag.setAttribute('onmouseover', 'refreshWishlistItems()');
        }
        if(wishlistCount){
          wishlistCount.innerHTML = productCount;
        }
        if(productCount > 3){
          var wlGridList = document.querySelector('.wishlist-grid-desktop');
          wlGridList.style.maxHeight = '470px';
          wlGridList.style.overflowY = 'scroll';
        }else{
          console.log('no max height')
        }
      
	});
}

function attachClickListeners() {
	var addToCartButtons = document.querySelectorAll("#swym-custom-add-toCartBtn");
	var removeBtns = document.querySelectorAll("#swym-remove-productBtn");
	//   Add to cart Btns
	for (var i = 0; i < addToCartButtons.length; i++) {
		addToCartButtons[i].addEventListener('click', onAddToCartClick, false);
	}
	//   Remove Buttons
	for (var k = 0; k < removeBtns.length; k++) {
		removeBtns[k].addEventListener('click', onRemoveBtnClick, false);
	}
	console.log("Events attached!");
}

if (!window.SwymCallbacks) {
	window.SwymCallbacks = [];
}

window.SwymCallbacks.push(swymRenderWishlist); /* Init Here */

// Get all buttons with the class 'wishlist-button'
var wishlistButtons = document.querySelectorAll('.wishlist-button');


// Attach a click event listener to each button
wishlistButtons.forEach(function(button) {
  button.addEventListener('click', function(event) {
    addToWishlist(event); // Pass the event object
    console.log('buttonclick');
  });
});


// Define the function to handle the click event
function addToWishlist(event) {
  // Get the specific button that was clicked
  var clickedButton = event.target;

 var wishlistCountElement = document.getElementById("wishlistcount");
 var wishListTag = document.querySelector('.custom-wishlist-a')
 var wishlistContainerList = document.getElementById("custom-swym-container")
 var value = wishlistCountElement.textContent;

function swymRenderWishlistCount(swat) {
	// Get wishlist items
	swat.fetch(function(products) {
        var wishlistCount = document.getElementById("wishlistcount");
		var formattedWishlistedProducts = products.map(function(p) {
			p = SwymUtils.formatProductPrice(p); // formats product price and adds currency to product Object
			p.isInCart = _swat.platform.isInDeviceCart(p.epi) || (p.et == _swat.EventTypes.addToCart);
			p.variantinfo = (p.vi ? getVariantInfo(p.vi) : "");
			return p;
		});
     

        var productCount = formattedWishlistedProducts.length;

        if(wishlistCount){
          wishlistCount.innerHTML = productCount;
        }
        if(productCount > value ){
           refreshWishlistItems()
        }
        if(productCount === 0 ){
          wishlistCountElement.style.display = 'none' 
          wishListTag.removeAttribute('onmouseover');
          wishlistContainerList.style.display = 'none'
          console.log('hide wishlist count')
        }
      
	});
}

// Define the delay (in milliseconds) before executing swymRenderWishlist
var delayInMilliseconds = 2000;

// Use setTimeout to execute swymRenderWishlist after the specified delay
setTimeout(function () {
  console.log('pushed')
window.SwymCallbacks.push(swymRenderWishlistCount);
}, delayInMilliseconds);
  
}

